import React from 'react'
import { useStaticQuery, graphql } from 'gatsby'

import { Hero } from '../components/_common'
import { Contact } from '../components/IndexModule'
import { UsContent, Purpose, Values } from '../components/UsModule'
import { Layout } from '../components/_layout'

const getInfo = graphql`
  {
    bgImg: file(relativePath: { eq: "bg.jpg" }) {
      childImageSharp {
        fluid(quality: 90, maxWidth: 4160) {
          ...GatsbyImageSharpFluid_withWebp
        }
      }
    }
  }
`

const Nosotros = () => {
  const { bgImg } = useStaticQuery(getInfo)

  return (
    <Layout withNav seoTitle="Nosotros">
      <Hero
        secondary
        img={bgImg.childImageSharp.fluid}
        pageTitle="Quiénes somos"
      />
      <UsContent />
      <Purpose />
      <Values />
      <Contact />
    </Layout>
  )
}

export default Nosotros
